export type BookingOutcome = 'confirmed' | 'pending' | 'manual_review' | 'expired' | 'cancelled' | 'refunded' | 'partially_refunded' | 'unknown'

// Booking state alone never proves that money was received. Unassigned is the
// normal paid outcome for equipment assigned by staff after checkout.
export function bookingOutcome(state: string, payment: string | null): BookingOutcome {
  if (state === 'cancelled' || state === 'expired') return state
  if (payment === 'refunded' || payment === 'partially_refunded') return payment
  if (state === 'manual_review') return 'manual_review'
  if (['confirmed', 'unassigned', 'returned'].includes(state) && payment === 'paid') return 'confirmed'
  if (['payment_pending', 'confirmed', 'unassigned'].includes(state) && payment === 'unpaid') return 'pending'
  return 'unknown'
}

export function isFinalBookingOutcome(outcome: BookingOutcome) {
  return outcome !== 'pending' && outcome !== 'unknown'
}

export function bookingOutcomeWarning(state: string, payment: string | null): string | null {
  const outcome = bookingOutcome(state, payment)
  if (outcome === 'confirmed') return null
  const labels: Record<Exclude<BookingOutcome, 'confirmed'>, string> = {
    pending: 'Payment pending',
    manual_review: 'Manual review',
    expired: 'Checkout expired',
    cancelled: 'Booking cancelled',
    refunded: 'Payment refunded',
    partially_refunded: 'Payment partially refunded',
    unknown: 'Booking/payment status needs checking',
  }
  return labels[outcome]
}
